import React, { useContext } from 'react';

/* packages */
import { Fetch } from '../../../lib-atomic-functions';
/* packages */

/* stores */
import Store from './store';
/* stores */

const index = ({CONFIG}) => {
  const orderListContext  = useContext(Store);
  const orderListMethod = async ({token}) => {
    orderListContext.setLoading({loading: true, status: false, data: false});
    CONFIG.application.order.api.headers.Authorization = token;
    const fetch = await Fetch({
      url: CONFIG.application.order.api.endpoints.list.url,
      config: {
        method: CONFIG.application.order.api.endpoints.list.method,
        headers: CONFIG.application.order.api.headers
      }
    });
    orderListContext.setLoading({loading: false, status: fetch[0], data: fetch[1]});
  }

  return { orderListContext, orderListMethod }
}

export default index;
